var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-avatar"},[(_vm.user.avatar)?_c('img',{staticClass:"user-avatar__img img-fluid rounded-circle",class:_vm.size,attrs:{"src":_vm.user.avatar}}):_c('b-avatar',{staticClass:"user-avatar__img",class:_vm.size,attrs:{"text":_vm._f("initial")(_vm.user.name)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }